/**
 * Helper to resolve and normalize the user avatar/profile photo URL.
 * Supports absolute URLs (e.g. S3), relative local paths, and environment-aware backend routing.
 * Bypasses Vite proxy issues for static files in local development.
 */
export const getAvatarUrl = (avatar) => {
  if (!avatar) return null;

  // If it's already an absolute URL (e.g. Amazon S3 or external URL)
  if (avatar.startsWith('http://') || avatar.startsWith('https://')) {
    return avatar;
  }

  // Replace backslashes with forward slashes
  const normalizedPath = avatar.replace(/\\/g, '/');

  // Strip leading slash if present
  const cleanPath = normalizedPath.startsWith('/') ? normalizedPath.substring(1) : normalizedPath;

  // Detect if running in local development
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  if (isLocal) {
    // In local development, fetch directly from the backend on port 8000 to bypass proxy 500 errors
    return `http://localhost:8000/${cleanPath}`;
  }

  // In production, Nginx will serve the uploads directory statically
  return `https://crm.doxez.in/${cleanPath}`;
};
